import { setLogDatapointFunc } from "owa-performance";
import { logUsage } from "./api/logUsage";
import type { DatapointOptions, CustomData } from "owa-analytics-types";
import type { AnalyticsEventNames, AnalyticsCoreEventNames } from "owa-analytics-events";

// The performance layer may pass either usage or core names;
// the bridge ultimately routes to logUsage (usage events), which matches existing behavior.
type Events = AnalyticsEventNames | AnalyticsCoreEventNames;

const logDatapointBridge = <TKeys extends string = string>(eventName: Events, customData?: CustomData<TKeys>, options?: DatapointOptions, shouldYield?: boolean): void | Promise<void> => {
    // We forward to usage logging; mailbox is not available here, so pass undefined.
    /* eslint-disable-next-line owa-custom-rules/telemetry-mailboxinfo-as-second-param -- (https://aka.ms/OWALintWiki)
     * BASELINE: DO NOT COPY/PASTE!
     *	> Argument at index 1 for logUsage must be of type MailboxInfo and not undefined. Telemetry calls that violate this rule will eventually be removed by the framework team. https://aka.ms/owa-analytics-mailboxinfo */
    return logUsage(eventName as AnalyticsEventNames, undefined, customData, options, shouldYield);
};

/* eslint-disable-next-line owa-custom-rules/no-side-effects -- (https://aka.ms/OWALintWiki)
 * DO NOT COPY-PASTE!, this function can't be called in the module scope, please move it inside a function
 *	> Function setLogDatapointFunc called at module scope is not allowed. This may cause unwanted side effects. */
setLogDatapointFunc(logDatapointBridge);

export { lazyOneDSFlush, lazyGetResourceTimingForUrl, lazyLogDatapoint, lazyLogAddinsCustomerContent, lazyLogAddinsTelemetryEvent, lazyInitializeAnalytics, lazyLogSecondaryAccountSessionDatapoint, } from "./lazyFunctions";
/* eslint-disable-next-line owa-custom-rules/forbid-package-reexport  -- (https://aka.ms/OWALintWiki)
 * Baseline comment; do not copy-paste. Rexporting from a separate package complicates the package graph.
 *	> Do not re-export from a separate package */
export { DatapointVariant, DatapointStatus, EventArea } from "owa-analytics-types";
export { AriaDatapoint } from "./datapoints/AriaDatapoint";
export { PerformanceCoreDatapoint } from "./datapoints/PerformanceCoreDatapoint";
export { PerformanceDatapoint, defaultDatapointTimeout, incrementReactionCount, } from "./datapoints/PerformanceDatapoint";
export { default as VerboseDatapoint } from "./datapoints/VerboseDatapoint";
export { default as UsageDatapoint } from "./datapoints/UsageDatapoint";
export { UsageCoreDatapoint } from "./datapoints/UsageCoreDatapoint";
export { addDatapointMiddleware, returnTopExecutingActionDatapoint, wrapFunctionForDatapoint, wrapFunctionForCoreDatapoint, declineActionDatapoint, } from "./DatapointMiddleware";
export { logCoreUsage } from "./api/logCoreUsage";
export { logUsage };
export { logCoreGreyError } from "./api/logCoreGreyError";
export { logGreyError, registerGreyErrorListener } from "./api/logGreyError";
export { logDatapoint } from "./api/logDatapoint";
export { logVerboseUsage } from "./api/logVerboseUsage";
export { logUnifiedTelemetry } from "./api/logUnifiedTelemetry";
export { createErrorWithErrorCode } from "./utils/createErrorWithErrorCode";
export { useRenderStats } from "./hooks/useRenderStats";
